/**
 * Statistics/GetLog yanıtını satır listesine çevirir.
 *
 * Üretilen OpenAPI tipi `data`'yı `{ log: string }` diyor, panelde ise dizi gibi
 * map'leniyordu — yani tip ile gerçek yanıt uyuşmuyor. Şekil netleşene kadar
 * üç ihtimali de karşılıyoruz: düz dizi, tek parça metin, `{ log }` sarmalı.
 */
export const toLogLines = (data: unknown): string[] => {
  if (!data) return [];

  if (Array.isArray(data)) return data.map((item) => String(item));

  if (typeof data === "string") {
    return data.split("\n").filter((line) => line.trim());
  }

  if (typeof data === "object") {
    const log = (data as { log?: unknown }).log;

    if (Array.isArray(log)) return log.map((item) => String(item));
    if (typeof log === "string") {
      return log.split("\n").filter((line) => line.trim());
    }
  }

  return [];
};

export default toLogLines;
